<template>
  <div class="cpunk_page with-navbar">
    <div class="only-desktop">
      <top-bar></top-bar>
    </div>
    <rebuild-nav-bar></rebuild-nav-bar>

    <div class="protocol-container">
      <h1 class="protocol-title only-mobile">&nbsp;保乐力加（中国）<br>官方网站使用条款</h1>
      <h1 class="protocol-title only-desktop">&nbsp;保乐力加（中国）官方网站使用条款</h1>
      <div class="desc">
        <p class="mt10">本网站由保乐力加（中国）贸易有限公司或其自行委托的第三方运营（以下称为“保乐力加中国”）。</p>
        <p class="mt10">当您登陆absolutnights.com（以下简称“本网站”），即表明您同意以下使用条款。如果您不同意这些使用条款，请勿使用本网站。保乐力加中国将保留随时改变、修改、增加或删除部分使用条款的权利。请您定期查阅使用条款做出的改动，因为任何改动对您都有约束力：</p>
      </div>

      <h5 class="sub-title">条款 1. 不当传播</h5>
      <p>1.1 您不应鼓励或纵容过量或不负责任饮酒的行为，也不应以任何形式贬低戒酒或适量饮酒的行为。</p>
      <p>1.2 您的传播中不应出现醉酒的人, 或以其它任何形式暗示醉酒是可接受的。</p>
      <p>1.3 您的传播不应暗示饮酒与暴力、攻击、违法、危险或反社会行为之间存在任何关联。</p>
      <p>1.4 您的传播应避免任何与毒品文化或违禁药品之间的关联，也不应出现接受或暗指 毒品 文化或违禁药品的信息。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.1 绝不鼓励不负责任饮酒和过度饮酒的行为。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.2 不向表现出兴奋失控、醉酒、具有攻击性或有反社会行为的人提供产品。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.3 不得向不愿参与活动的人施加任何压力。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.4 不得消极对待对促销活动不感兴趣的人。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.5 清晰、恰当地展现提醒人们理性饮酒的信息。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.6 确保活动的任何环节(如内容、语言、促销团队的行为、价格/时间安排等)都不会鼓励过度饮酒或不负责任饮酒的行为。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.7 如果促销活动涉及购买数量，饮酒不要超过国家建议的合理饮酒量。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1.4.8 促销活动和信息不得鼓励从事冒险或有潜在危险的活动或行为。</p>
      <h5 class="sub-title">条款 2. 未成年人</h5>
      <p>2.1  您必须达到法定饮酒年龄才能浏览、使用本网站。</p>
      <p>2.2 不应以未成年人为目标受众，也不应出现未成年人饮酒的场景。</p>
      <p>2.3 不使用任何会导致过度饮酒或不负责任饮酒行为的“饮酒游戏”，如比赛“喝酒速度”或在一定短时间内比赛喝酒数量等活动。</p>
      <p>2.4 您的传播不应使用尤其对儿童或青少年具有吸引力的物体、形象、风格、符号、 颜色、 音乐和人物——不论是真实的还是虚构的，包括卡通人物或体育明星等著 名人物。</p>
      <p>2.5 您的传播不应使用尤其对未成年人具有吸引力的名字、标识、游戏、游戏设备或其它 事物作为品牌识别手段。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.1 绝不参与邀请未满法定购酒或饮酒年龄者参加活动。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.2 不得允许未满法定饮酒年龄的人参与活动。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.3 如受众中未满法定饮酒年龄的人，根据客观估计达到 30%以上，则不得开展促销活动。 如对受众年龄构成不确定，不得进行活动(由于各国情况不同，请核实各国相应的百分比)。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.4 考虑通过展示来提醒消费者——只有达到法定购酒年龄的人才能消费酒类产品 (请参 见“不当传播”条款的“f 点”)</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.5 如果对消费者的年龄不确定，可要求出示可证明其年龄的证件(注意有关要求他 人出示身份/年龄证明的国家法律和法规)。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.6 确保促销活动的各个环节(如内容、语言、卡通形象、音乐、名人等)都不会首 先对未满法定饮酒年龄的人群构成强烈吸引力。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2.5.7 酒类品牌不应出现在儿童装/青少年装上。</p>
      <h5 class="sub-title">条款 3. 酒后驾驶</h5>
      <p>传播不应暗示在驾驶各种机动交通工具前或驾驶时饮酒是可以接受的，包括快艇、摩托艇、雪地摩托和飞机。</p>
      <p>1.对参加完活动后可能会驾车的消费者(如在超市试饮)需特别注意。</p>
      <p>2.考虑展示“请勿酒后驾车”的信息。</p>
      <p>3.谨慎对待在与驾驶密切相关的场所(如高速公路边的商店和餐厅)开展的促销活动。</p>
      <p>4.机动交通工具可以作为促销奖品，但在颁奖时需确认不能由饮酒后的人驾驶 (如: 车钥匙可在颁奖典礼后的第二天交付给获奖人)。</p>
      <h5 class="sub-title">条款 4. 危险活动、工作场所和娱乐项目</h5>
      <p>不应暗示在操作有潜在危险的机器、从事有潜在危险的娱乐或工作活动之前或同时饮酒是可接受的行为。</p>
      <p>确保促销活动不涉及或鼓励危险活动。</p>
      <h5 class="sub-title">条款 5. 健康</h5>
      <p>5.1  不应宣称酒具有治疗作用，可以帮助预防、治疗或治愈任何人类疾病。</p>
      <p>5.2 可以在法律允许的范围内，在某些具体适用的情况下使用真实准确的事实性 陈述来说明酒中含有的碳水化合物、卡路里或其它营养物质。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;5.2.1 确保活动的任何环节都不会暗示产品有预防、治疗或治愈人类疾病的功效。</p>
      <h5 class="sub-title">条款 6. 妊娠 商业传播不应出现孕妇饮酒的场景或以孕妇为目标受众进行宣传。</h5>
      <h5 class="sub-title">条款 7. 酒精度数</h5>
      <p>7.1 传播应当清楚地说明酒的性质和酒精浓度。</p>
      <p>7.2 传播可以向用户传达关于酒精度数的信息，但不得在品牌宣传材料中将高酒精浓度作为一个重要主题来强调。另一方面，传播信息不能暗示饮用低度酒就不会导致酗酒。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;7.2.1 确保活动的参与者知道饮品中含有酒精。</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;7.2.2 不得使用可能让消费者对酒精摄入量产生迷惑或误解的供酒方式或小器具(如喷酒器和蒸馏器)。</p>
      <h5 class="sub-title">条款 8. 能力表现</h5>
      <p>传播不应当暗示人们在从事需全神贯注以避免发生危险的活动时可以通过饮酒来增强心智或生理能力，也不应暗示饮酒具有提神的效果。</p>
      <p>1.不鼓励或提倡运动前饮酒。</p>
      <p>2.不发起与功能饮料联合进行的市场推广和营销。</p>
      <h5 class="sub-title">条款 9. 社交表现</h5>
      <p>传播不应暗示饮酒是人们在社交生活中获得认可或取得成功的必要条件。</p>
      <h5 class="sub-title">条款 10. 性能力</h5>
      <p>10.1 在任何情况下，传播都不应当违反商业道德，违反约定俗成的审美价值与道德标准或对人的尊严和人格进行攻击。</p>
      <p>10.2 传播不应当暗示饮酒可以增强性能力、吸引力或者有助于建立性关系。</p>
      <h5 class="sub-title">条款 11. 赠饮</h5>
      <p>不应向未成年人提供赠饮; 赠饮活动应在有酒类经营执照的场所、私人住所、交易会或符合当地法规的场所进行。</p>
      <p>商业传播行为准则和促销活动自律准则中的条款同样适用于赠饮。例如，应该告知消费者他们试饮的酒的种类及酒精浓度，不得向醉酒者提供赠饮，不得向可能将从事冒险或危险活动，或反社会活动的人提供赠饮。</p>
      <h5 class="sub-title">条款 12. 禁止使用的终端销售用品/促销品</h5>
      <p>不得使用导致下列情况发生的酒器、小器具、喷酒器或其它酒类计量器:</p>
      <p>鼓励过量饮酒的行为</p>
      <p>不易计算自己正在摄入的酒精量(如使用酒类喷射器、无液气体酒喷射器)</p>
      <p>无法控制酒精的摄入量或摄入速度(如在一些饮酒游戏中使用的灌酒器具)</p>
      <p>不得使用与医疗用品相关的酒器、小器具或酒类计量器(如注射器、试管)</p>
      <p>不得使用冒犯性的宗教符号或其它符号与题材</p>
      <p>甜点或儿童糖果:不得使用儿童糖果和甜食;可以使用成人糖果，如酒心巧克力、黑巧克力。</p>
      <p>不得使用对未成年人具有强烈吸引力的奖品和游戏</p>
      <p>不得开展饮酒比赛或容易导致不负责任饮酒行为的游戏</p>
      <p>不得开展带有性内容或性含义的诱惑游戏</p>
      <p>在水中使用的充气物品(例如救生圈、气垫、充气床、充气枕头、充气椅子等)</p>
      <p>不得对未成年人具有强烈吸引力</p>
      <p>不得使用儿童服装或任何其它与儿童相关的产品</p>
      <p>不得使用性玩具</p>
      <p>不得使用以酒类品牌命名的避孕套</p>
      <p>不得使用宿醉治疗</p>
      <h5 class="sub-title">条款 13: 知识产权</h5>
      <p>未经保乐力加中国书面允许，不能以任何形式拷贝、复制、分发、转载、上传、张贴、或传送本网站的任何资料。使用或登陆本网站时，您不因此享有本网站的名称的使用权以及知识产权；保乐力加中国拥有本网站所有方面的权利以及利益。网站提供的所有材料仅供合法使用。</p>
      <p>在任何情况下，保乐力加中国或其附属公司、子公司、母公司或其他关联公司将不对与使用、登陆、或无法使用本网站及其任何信息相关、或因此引起的任何损坏和伤害、或者由操作传输的性能、错误、遗漏、中断、缺陷、延迟以及计算机病毒或线路故障造成的任何损失、损坏和伤害负有任何责任（包括，但不限于直接、偶然、必然、间接或惩罚性的赔偿）。本网站提供的资料可能出现技术错误或者排版问题。本网站所提供的资料不附带任何形式的明示或暗示的担保。保乐力加中国在现行中国法律允许的最大程度上不对因疏忽对他人造成的损失负责，不做出任何形式上和暗含的承诺担保，包括但不限定于暗含的适售性、特定目的的适用性、或未侵害他人权利。保乐力加中国不保证本网站的功能不间断运行且没有任何错误，不保证本网站提供的内容准确无误真实可信，也不保证本网站及支持本网站运行的服务器没有病毒或其它有害成分。您（而不是保乐力加中国）将承担个人所有必要维修及修复的全部费用。</p>
      <p>所有通过本网站交流或者发送至保乐力加中国的评论、建议、观点、创意、图表、或者其他信息，包括但不限于产品或广告计划（以上统称为“提交信息”）永久属于 保乐力加中国 所独有，在不违反法律强制性规定的情况下，保乐力加中国 无义务将所提交信息作为机密资料，也不对信息的使用以及泄漏负任何责任，并无需对此做任何赔偿和确认。保乐力加中国 对现在和未来任何形式的提交信息有唯一所有权、知识产权及其他权利，包括对提交信息的使用权、复制权、修改权、改编权、发行权、传输权、创造派生产品权、分发权、执行权以及展示权。您必须同意不向本网站提交任何构成或可能鼓动犯罪或违法行为的侵权、违法、威胁、中伤、诽谤、淫秽、色情或亵渎宗教的资料或包含垃圾信息或广告内容的资料，并且所有提交信息符合本使用条款的要求。你必须对您发送的提交信息的合法性、可靠性以及原创性负完全责任，保证您的提交信息不侵犯任何第三人知识产权，未设置任何权利负担，保乐力加中国对此不负任何责任。向本网站提交信息表明您已经承认保乐力加中国 有权以任何理由对本网站的内容进行删除。保乐力加中国保留过滤/删除所有违反使用条款的个人帖子以及提交信息的权利。</p>
      <p>遵守中华人民共和国（“中国”）相关知识产权保护法和国际公约。我们一贯对侵权申诉作出快速反应。如果您确定本网页出现侵权作品，您可以向以下地址发送以下信息以通知我们的注册版权代理商：</p>
      <p>1.代表版权所有者的受权人签名。该签名可以是手书签名也可以是电子签名。</p>
      <p>2.代表版权所有者的受权人声明。</p>
      <p>3.本人的声明函，说明其相信我们以此方式使用该资料即未得到版权所有人的授权、也没有得到所有者代理人或法律的授权；</p>
      <p>4.一份您申诉受侵权的版权作品说明，以及一份侵权材料在本网站的具体位置的说明；以及</p>
      <p>5.您的地址、电话号码、以及电子邮件地址。</p>
      <p>请将在邮件主题中注明“侵权通知”字样，邮件请寄至 【absolutnights@pernod-ricard.com】。</p>
      <p>我们将按照中国相关法律的要求处理和调查所有侵权申诉，并将删除或停止侵权资料或含有侵权活动主题的链接。当我们删除或停止侵权资料的链接后，我们会联系疑似提交侵权信息的用户，让他／她有机会对“侵权通知”做出陈述和申辩。如果提交侵权材料的用户声明该资料已经合法授权，我们将尽可能自行或要求该用户回复“侵权通知”发送方，使该“侵权通知”发送方在我们恢复任何材料的链接之前有机会向相关机构寻求法律援助。</p>
      <h5 class="sub-title">条款 14：免责</h5>
      <p>本网站包括其他网站和资源链接。保乐力加中国对本网站链接的外部网站及其资源的有效性不承担责任，也不对这些网站中出现或链接的任何内容、广告、产品或者其他材料承担责任。您与任何第三方的交易仅限于您与第三方之间，保乐力加中国对此免责。建议您在浏览此类网站时应阅读其使用条款，因为这些使用条款可能与我们的使用条款存在差异。您应向这些第三方网站的管理员联系咨询相关问题。</p>
      <h5 class="sub-title">条款 15：法律适用</h5>
      <p>不管任何冲突法原则，本协议应将以中国法律为准。除另有说明外，本网站上所有资料的目的仅为提供有关保乐力加中国的信息，保乐力加中国将自行或委托第三方在【People’s Republic of China中华人民共和国】控制并运行本网站，而不保证这些资料在其他地点可以使用。如果您在其他地点使用本网站，您还应当同时遵守当地相关法律。</p>
      <h5 class="sub-title">条款 16：保乐力加商标</h5>
      <p>以下商标以及所有相关标志和设计均属保乐力加中国及其／或者其关联公司、子公司、母公司或相关公司所有：</p>
      <p>*ABSOLUT</p>
      <p>*绝对伏特加 ABSOLUT Vodka</p>
      <p>*ABSOLUT country of Sweden Vodka</p>
      <p>*ABSOLUT酒瓶设计</p>
      <p>*ABSOLUT字体</p>
      <p>*absolut.com</p>
      <p>*absolutvodka.com</p>
      <p>*绝对伏特加原味ABSOLUT VODKA</p>
      <p>*绝对伏特加柠檬风味 ABSOLUT CITRON</p>
      <p>*绝对伏特加柑橘味 ABSOLUT MANDRIN</p>
      <p>*绝对伏特加红莓味 ABSOLUT RASBERRI</p>
      <p>*绝对伏特加苹果梨味 ABSOLUT PEARS</p>
      <p>*绝对亦乐伏特加 ABSOLUT ELYX</p>
      <p>未经授权，禁止使用以上商标或本网站任何内容，也不得以其他任何方式侵犯以上商标或本网站任何内容的商标权、著作权及其他一切权利。所有其他商标归相关商标所有者所有。</p>
      <h5 class="sub-title">条款 17：网站使用</h5>
      <p>本网站作为一项作品受到中国相关知识产权保护法、国际公约及其它版权法保护。除了按照以上条款使用本网站外，您不能修改、改编、翻译、展示、发表、传输、以及参加转让或销售、复制（除非在使用条款中另有说明）、创造衍生作品、分发、执行、展示、还原方案、反编译或反汇编、或者以任何一种方式利用本网站的全部或部分内容、软件、资料或网站。</p>
      <p>您可以为个人、非商业用途登陆本网，但是不能在互联网或其它地方上复制或发布本网站内容。未经 保乐力加中国或者个人财产声明（包括版权声明）中指定的版权所有者的事先书面允许，禁止复制或存储本网站任何内容用于非个人用途和/或商业用途。</p>
      <h5 class="sub-title">条款18：税款</h5>
      <p>本活动中涉及的奖金的个人所得税由保乐力加中国代扣代缴。中奖者应配合提供相应纳税证明文件，若因中奖者不能按照保乐力加中国的通知在通知中明确的时间内提供相应文件而导致其无法领取奖金的，本网站不承担任何责任。</p>
      <h5 class="sub-title">条款19：争议解决</h5>
      <p>一切因本使用条款引起的纠纷，请您与保乐力加中国协商解决，协商不成的，任何一方可交由上海国际经济贸易仲裁委员会按照当时适用的仲裁规则进行仲裁，仲裁结果是终局的，对双方均有约束力。仲裁费用由败诉一方承担。</p>
      <h5 class="sub-title">条款20：提交信息的使用</h5>
      <p>所有通过本网站交流或者发送至保乐力加中国的评论、建议、观点、创意、图表、或者其他信息，包括但不限于产品或广告计划（以上统称为“提交信息”），保乐力加中国有权二次使用其内容于绝对伏特加官方微博，绝对伏特加官方微信，绝对伏特加官方Nice，绝对伏特加官方优酷等全部自媒体平台。</p>
      <p class="mt40">本人已经认真阅读并同意以上内容。</p>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBar from '@components/TopBar'
import RebuildNavBar from '@components/RebuildNavBar'
import PageFooter from '@components/PageFooter'

export default {
  name: 'Protocol',
  components: {
    TopBar,
    RebuildNavBar,
    PageFooter,
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.protocol-container {
  padding: 40px 30px;
  text-align: justify;
  font-weight: 500;
  font-size: 1.2rem;
  color: #fff;
  line-height: 180%;
  position: relative;
  @include respond-to(desktop) {
    max-width: 960px;
    margin: 0 auto;
    line-height: 200%;
  }
  .protocol-title {
    margin-bottom: 24px;
    font-weight: 900;
    font-size: 2rem;
    color: #fff;
    opacity: 0.9;
    text-align: center;
    font-family: 'Absolut-Bold';
    // text-shadow: 2px 2px 0 nth($, 3);
  }
  .sub-title {
    margin: 24px 0 8px;
    font-weight: bold;
    font-size: 2rem;
    color: #fff;
    text-align: center;
    @include respond-to(desktop) {
      text-align: left;
      font-size: 1.4rem;
    }
  }
  .desc {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Regulation.vue